import { Label, Text, type TypeLabelProps } from '@thefarmersfront/kitchen';

import clsx from 'clsx';

import styles from './ModalLabelValueRow.module.scss';

const ModalLabelValueRow = ({
  label,
  value,
  tooltip,
  alignItems = 'center',
  className,
}: {
  label: string;
  value: React.ReactNode;
  tooltip?: TypeLabelProps['tooltip'];
  alignItems?: 'center' | 'start';
  className?: string;
}) => {
  return (
    <div className={clsx(styles['row-container'], styles[`align-items-${alignItems}`], className)}>
      <Label className={styles['label']} title={label} tooltip={tooltip} />
      {typeof value === 'string' ? (
        <Text className={styles['value']} size="large" element="span">
          {value || '-'}
        </Text>
      ) : (
        <div className={styles['value']}>{value}</div>
      )}
    </div>
  );
};

export default ModalLabelValueRow;
